const initialState = {
  loading: false,
  //cost: "0",
  stake: " ",
  unstake: " ",
  hasRewards: " ",
  released: " ",
  totalReleased: " ",
  payees: " ",
  share: " ",
  deployedContract: "",
  error: false,
  errorMsg: "",
  addresses: ""
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECK_DATA_REQUEST":
      return {
        ...state,
        loading: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        //cost: action.payload.cost,
        //balance: action.payload.balance,
        account: action.payload.account,
        //totalReleased: action.payload.totalReleased,
        //payees: action.payload.payees,
        //hasStakes: action.payload.hasStakes,
        //SVIBESMinted: action.payload.SVIBESMinted,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS2":
      return {
        ...state,
        loading: false,
        //cost: action.payload.cost,
        //balance: action.payload.balance,
        //account: action.payload.account,
        totalReleased: action.payload.totalReleased,
        //SVIBESMinted: action.payload.SVIBESMinted,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS3":
      return {
        ...state,
        loading: false,
        //cost: action.payload.cost,
        //balance: action.payload.balance,
        //account: action.payload.account,
        payees: action.payload.payees,
        //hasStakes: action.payload.hasStakes,
        //SVIBESMinted: action.payload.SVIBESMinted,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS4":
      return {
        ...state,
        loading: false,
        //cost: action.payload.cost,
        //balance: action.payload.balance,
        //account: action.payload.account,
        share: action.payload.share,
        totalReleased: action.payload.totalReleased,
        released: action.payload.released,
        //hasStakes: action.payload.hasStakes,
        //SVIBESMinted: action.payload.SVIBESMinted,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS5":
      return {
        ...state,
        loading: false,
        //cost: action.payload.cost,
        //balance: action.payload.balance,
        //account: action.payload.account,
        addresses: action.payload.addresses,
        //hasStakes: action.payload.hasStakes,
        //SVIBESMinted: action.payload.SVIBESMinted,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS6":
      return {
        ...state,
        loading: false,
        //cost: action.payload.cost,
        //balance: action.payload.balance,
        //account: action.payload.account,
        deployedContract: action.payload.deployedContract,
        //hasStakes: action.payload.hasStakes,
        //SVIBESMinted: action.payload.SVIBESMinted,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_FAILED":
      return {
        ...initialState,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default dataReducer;
